<app-travelers-setting
        [travelersConfig]="panelData"
        (payload)="emittedValuesHandler($event)"
></app-travelers-setting>

<div class="f-row f-center" (click)="submitPanel()">
    <button class="btn-default btn-primary">
        {{ 'DONE' | translate }}
    </button>
</div>
